export default "__VITE_ASSET__CthoQZ7c__"